import React, { lazy } from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-8 pb-8 px-5 text-center border-b border-cream" data-id="element-83">
      <div className="inline-block px-3 py-1 bg-sage/10 text-sage font-subheading font-bold text-xs mb-4 border border-sage/30" data-id="element-84">
        ✨ METODO DI COACHING VALIDATO
      </div>

      <h1 className="text-3xl font-heading font-bold text-petrol leading-tight mb-4" data-id="element-85">
        Il Sistema Completo di Pianificazione per Coach di Functional Training
      </h1>

      <p className="text-base text-graphite font-body leading-relaxed mb-6" data-id="element-86">
        Risparmia ore di programmazione, crea allenamenti professionali e guida
        i tuoi clienti con maggiore sicurezza — senza dover costruire ogni
        lezione da zero.
      </p>

      <div className="mb-6" data-id="element-87">
        <p className="font-subheading font-bold text-sm text-petrol mb-2" data-id="element-88">
          FUNCTIONAL READY™ 6-in-1 Complete System
        </p>
        <a href="#pricing" className="block" data-id="element-89">
          <img src="https://cdn.magicpatterns.com/uploads/h9zfmASQDwvzTrNnkPRn2A/ChatGPT-Image-16-jun-2026_-21_22_56.webp" alt="FUNCTIONAL READY 6-in-1 Complete System" className="w-full h-auto object-contain max-w-[280px] mx-auto" loading="lazy" data-id="element-90" />
        </a>
      </div>

      <div className="mb-4" data-id="element-91">
        <CTAButton data-id="element-92">🚀 SÌ, VOGLIO IL MIO SISTEMA ORA</CTAButton>
      </div>

      <div className="flex flex-col gap-2 text-xs text-graphite font-bold" data-id="element-93">
        <div data-id="element-94">⭐ 4.9/5 — Recensioni Verificate di Professionisti</div>
        <div data-id="element-95">🛡️ Garanzia di 7 Giorni — Zero Rischi</div>
      </div>
    </section>;
}